import { format } from 'date-fns';
import { es, enUS } from 'date-fns/locale';
import type { TFunction } from 'i18next';

export function parseNotificationDate(dateString: string): Date | null {
  if (!dateString) return null;
  try {
    const normalized = dateString.includes('T') ? dateString : dateString.replace(' ', 'T');
    const d = new Date(normalized);
    return Number.isNaN(d.getTime()) ? null : d;
  } catch {
    return null;
  }
}

/**
 * Una sola fecha: relativa (hace X min / Xh) si es reciente; si no, fecha-hora absoluta.
 */
export function formatNotificationDateLabel(
  dateString: string,
  lang: string,
  t: TFunction
): string {
  const date = parseNotificationDate(dateString);
  if (!date) return '';

  const locale = lang === 'es' ? es : enUS;
  const absolute = format(
    date,
    lang === 'es' ? 'dd/MM/yyyy HH:mm' : 'MMM d, yyyy, h:mm a',
    { locale }
  );

  const now = new Date();
  const diffMin = Math.floor((now.getTime() - date.getTime()) / (1000 * 60));

  if (diffMin < 1) return t('notifications.date.justNow');
  if (diffMin < 60) return t('notifications.date.minutesShort', { count: diffMin });
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return t('notifications.date.hoursShort', { count: diffH });
  return absolute;
}
